import {GeofenceFormDefaultValues, GeofenceFormProps, GeofenceFormRawValues, GeofenceFormType} from "./GeofenceForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";
import {validateLatCoord, validateLongCoord} from "../form-utils";
import {geofenceTriggerType} from "@ots-frontend/ots-data";

const getInitialValues = (defaultValues: GeofenceFormDefaultValues | undefined): GeofenceFormRawValues => {
  return {
    triggerType: defaultValues?.triggerType?.code,
    latCoord: defaultValues?.latCoord,
    longCoord: defaultValues?.longCoord,
    radius: defaultValues?.radius,
    objectId: defaultValues?.object?.id,
    objectType: defaultValues?.object?.type,
  }
}

export type UseGeofenceFormProps = Pick<GeofenceFormProps, 'defaultValues'> & {}

export function useGeofenceForm(props: UseGeofenceFormProps): GeofenceFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
      triggerType: defaultValues?.triggerType ?? geofenceTriggerType.primary,
      radius: defaultValues?.radius ?? 150,
    }),
    validate: {
      triggerType: (value) => value ? undefined : t("common.validation.required", "Required"),
      latCoord: (value) => validateLatCoord(value, false, t),
      longCoord: (value) => validateLongCoord(value, false, t),
      objectId: (value) => value ? undefined : t("common.validation.required", "Required"),
      objectType: (value) => value ? undefined : t("common.validation.required", "Required"),
      radius: (value) => {
        if (typeof value === "undefined") {
          return t("common.validation.required", "Required")
        }

        if (value < 0) {
          return t("common.entity.geofence.form.validation.radius.greaterthanzero", "Radius Must Be Greater Than Zero")
        }

        return undefined
      },
    },
  })

  return form
}
